import { evidenceContract } from "@clipboard-health/contract-documents-service";
import { get } from "@src/appV2/api/parsedApi";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib/analytics";
import { DOCUMENT_EVIDENCES_QUERY_KEY } from "@src/appV2/redesign/Evidence/constants";
import { useQuery } from "@tanstack/react-query";
import { z } from "zod";

const queryParamsSchema = z.object({
  page: z.object({
    size: z.number(),
  }),
  filter: z.object({
    mongoDocumentId: z.string(),
  }),
});

const responseSchema = evidenceContract.list.responses[200];

export type EvidenceData = z.infer<typeof responseSchema>["data"][number];

export function useGetDocumentEvidences(mongoDocumentId: string) {
  const url = `${environmentConfig.REACT_APP_DOCUMENTS_SERVICE_REST_API_URL}/v2/evidences`;

  const query = useQuery({
    queryKey: [DOCUMENT_EVIDENCES_QUERY_KEY, mongoDocumentId],
    queryFn: async () => {
      const response = await get({
        url,
        queryParams: {
          page: { size: 100 },
          filter: { mongoDocumentId },
        },
        queryParamsSchema,
        responseSchema,
      });
      return response.data;
    },
    enabled: mongoDocumentId.length > 0,
    meta: { logErrorMessage: APP_V2_APP_EVENTS.GET_DOCUMENT_EVIDENCES_FAILURE },
  });

  return {
    evidences: query.data?.data ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
  };
}
